import { FC, useContext, useMemo } from "react";
import { QuizContext } from "../../providers/QuizProvider/QuizContext";
import { WelcomPage } from "../WelcomePage/WelcomePage";

type Props = {
  additions: any[];
  onStart?: () => void;
};

export const StartPage: FC<Props> = ({ additions, onStart }) => {
  const {
    title,
    title_config,
    description,
    description_config,
    button_text,
    button_text_config,
    image,
    addition_page_display,
  } = useContext(QuizContext);

  const additionsWithoutConsultant = useMemo(
    () => additions.filter(({ type }) => type !== 3),
    [additions]
  );
  return (
    <WelcomPage
      title={title}
      titleConfig={title_config}
      description={description}
      descriptionConfig={description_config}
      buttonText={button_text}
      buttonTextConfig={button_text_config}
      image={image}
      isShowAdditions={addition_page_display === 3}
      additionsWithoutConsultant={additionsWithoutConsultant}
      onStart={onStart}
      lockBonus={true}
    ></WelcomPage>
  );
};
